<template>
	<div class="flex flex-col items-center max-w-[720px] z-10">
		<div class="flex flex-wrap justify-center gap-1 mb-5">
			<BaseTagPill
				@click="onPillClick(category.id)"
				class="cursor-pointer"
				v-if="!showMore"
				type="pink"
				v-for="(category, index) in categoriesData"
				:key="index"
				v-show="index <= 4"
			>
				{{ category.name[locale] }}
			</BaseTagPill>
			<BaseTagPill
				@click="onPillClick(category.id)"
				class="cursor-pointer"
				v-else
				type="pink"
				v-for="(category, indexMax) in categoriesData"
				:key="indexMax"
			>
				{{ category.name[locale] }}
			</BaseTagPill>
		</div>
		<div class="flex items-center cursor-pointer" @click="showMore = !showMore">
			<span class="text-dj-blue text-xs">{{ showMore ? $t("hero.showLess") : $t("hero.showMore") }}</span>
			<BaseIcon
				class="text-[24px]"
				color="#1E64E1"
				:icon="showMore ? 'ic:outline-expand-less' : 'ic:outline-expand-more'"
			/>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import axios from "axios";
import { useI18n } from "vue-i18n";

export default defineComponent({
	name: "HeroCategories",
	async setup() {
		const categoriesData = ref([]);

		const showMore = ref(false);

		const { locale } = useI18n();

		let filterScope = "/tags?type[]=job-category&scope[]=hasAttachedJob&per_page=50";

		if (globalConfig.isBlue) {
			filterScope = "/tags?type[]=job-category&scope[]=hasAttachedJob&scope[]=isBlue&per_page=50";
		}

		if (globalConfig.isNotBlueHU) {
			filterScope = "/tags?type[]=job-category&scope[]=hasAttachedJob&scope[]=isNotBlue&per_page=50";
		}

		await axios(globalConfig.API + filterScope)
			.then((response) => {
				categoriesData.value = response.data.data;
			})
			.catch((error: any) => {
				console.error("HeroCategories fetch error", error.message || error);
			});

		function onPillClick(categoryId: number) {
			useRouter().push({
				path: `/${locale.value}/jobs`,
				query: {
					category: categoryId,
				},
			});
		}

		return {
			categoriesData,
			locale,
			showMore,
			onPillClick,
		};
	},
});
</script>
